import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    GetProductVariantChildrenApiV2Parameter,
    getVariantChildren,
} from "@insite/client-framework/Services/ProductServiceV2";
import { ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { VariantChildrenGridApiParameter } from "@thkStore/Types/VariantChildrenGridModel";

type Parameter = VariantChildrenGridApiParameter;
type Props = {
    apiParameter: GetProductVariantChildrenApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/BeginLoadProducts",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const {
        productId,
        page,
        pageSize,
        sort,
        searchWithin,
        attributeValueIds,
        filterAttributeValueIds,
        searchText,
    } = props.parameter;

    const additionalQueryStringParameters: Record<string, string> = {};

    if (searchWithin) {
        additionalQueryStringParameters.searchWithin = searchWithin;
    }

    if (attributeValueIds && attributeValueIds.length > 0) {
        additionalQueryStringParameters.attributeValueIds = attributeValueIds.join(",");
    }

    if (filterAttributeValueIds && filterAttributeValueIds.length > 0) {
        additionalQueryStringParameters.filterAttributeValueIds = filterAttributeValueIds.join(",");
    }

    if (searchText) {
        additionalQueryStringParameters.searchText = searchText;
    }

    props.apiParameter = {
        productId,
        page,
        pageSize,
        sort,
        expand: ["attributes", "facets", "documents", "properties"],
        includeAttributes: [],
        additionalQueryStringParameters:
            Object.keys(additionalQueryStringParameters).length > 0 ? additionalQueryStringParameters : undefined,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getVariantChildren(props.apiParameter);
};

export const DispatchCompleteLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/CompleteLoadProducts",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    DispatchBeginLoadProducts,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadProducts,
];

const loadVariantChildrenPage = createHandlerChainRunner(chain, "LoadVariantChildrenPage");
export default loadVariantChildrenPage;
